import { render } from "./confirm-dialogue.html?vue&type=template&id=4ff0bc63&scoped=true&ts=true&external"
import script from "./confirm-dialogue.ts?vue&type=script&lang=ts&external"
export * from "./confirm-dialogue.ts?vue&type=script&lang=ts&external"

import "./confirm-dialogue.scss?vue&type=style&index=0&id=4ff0bc63&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff0bc63"]])

export default __exports__